import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { AttachmentFolderPickerError } from './schema/AttachmentFolderPickerError';
import { AttachmentFolderPickerStore } from './schema/AttachmentFolderPickerStore';
import { createStore } from 'satcheljs';

const defaultStore: AttachmentFolderPickerStore = {
    isOpen: false,
    isLoading: false,
    error: AttachmentFolderPickerError.None,
    folderSelectorResult: null,
    providerViewState: { type: AttachmentDataProviderType.OneDrivePro },
};

export const getStore = createStore('attachmentFolderPicker', defaultStore);
